import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getCreateEventError() {
      return getState().error;
    },
    isCreateEventRequestFailure() {
      return getState().request.isFailure;
    },
    isCreateEventRequestPending() {
      return getState().request.isPending;
    },
    isCreateEventRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
